import { Link } from 'react-router-dom';
import {
  NotFoundBackLink,
  NotFoundBody,
  NotFoundCard,
  NotFoundPageLayout,
  NotFoundTitle,
} from '../components/styled';
import { useAuth } from '../context/AuthContext';

function NotFoundPage() {
  const { isAuthenticated } = useAuth();

  return (
    <NotFoundPageLayout>
      <NotFoundCard>
        <NotFoundTitle>Page not found.</NotFoundTitle>
        <NotFoundBody>
          The route you requested is not part of this starter layout.
        </NotFoundBody>
        <NotFoundBackLink
          as={Link}
          to={isAuthenticated ? '/library/songs' : '/login'}
        >
          {isAuthenticated ? 'Return to library' : 'Go to login'}
        </NotFoundBackLink>
      </NotFoundCard>
    </NotFoundPageLayout>
  );
}

export default NotFoundPage;
